import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CoreTracking } from "../../../../models/CoreTracking";
import ModalComponent from '../../../misc/ModalComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InactivateGoogleUserTracking } from "../../../../store/TrackingOperationAction";
import { EmptyRequestState } from "../../../../models/RequestState";
import StatusCode from "../../../../util/StatusCode";
import Loading from "../../../misc/Loading";
import CoreApiError from "../../../misc/CoreApiError";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../../store/store";



interface InactivateGoogleUserTrackingWizardProps {
    tracking: CoreTracking
    synched: Boolean
    close: (success: boolean) => void
}

const InactivateGoogleUserTrackingWizard: React.FC<InactivateGoogleUserTrackingWizardProps> = (props) => {
    const dispatch = useDispatch();
    const [wizardStep, setWizardStep] = useState<'confirm' | 'done'>('confirm');
    const inactivateGoogleUserTracking = useSelector<RootState, EmptyRequestState>(state => state.trackingOperation.inactivateGoogleUserTracking)
    const { t } = useTranslation(['schoolAdministration', 'common']);

    const confirmInput: React.MouseEventHandler<HTMLButtonElement> = (_) => {
        InactivateGoogleUserTracking(props.tracking.trackingId)(dispatch);
        setWizardStep('done');
    }

    const close = (success: boolean) => {
        setWizardStep('confirm');
        props.close(success);
    }

    switch (wizardStep) {
        case 'confirm': {
            return <ModalComponent
                isOpen={true}
                toggleModal={() => close(false)}
                header={t('trackingOperations.google.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                update={confirmInput}
                confirm={t('action.confirm', {ns: 'common'})}
                cancel={t('action.cancel', {ns: 'common'})}>
                <p><FontAwesomeIcon title={t('status.warning', {ns: 'common'})} color="#fc1" icon={['fas', 'triangle-exclamation']} /> {props.synched
                ? t('trackingOperations.google.inactivate.warningSynched', {ns: 'schoolAdministration',SourceSystemId: props.tracking.sourceSystemId })
                : t('trackingOperations.google.inactivate.warning', {ns: 'schoolAdministration', SourceSystemId: props.tracking.sourceSystemId, TrackingId: props.tracking.trackingId })}</p>    
            </ModalComponent>
        }
        case 'done': {
            if (inactivateGoogleUserTracking.code === StatusCode.COMPLETE) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(true)}
                    header={t('trackingOperations.google.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.close', {ns: 'common'})}>{t('trackingOperations.general.inactivateConfirm', {ns: 'schoolAdministration'})}</ModalComponent>
            } else if (inactivateGoogleUserTracking.code === StatusCode.ERROR) {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.google.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.cancel', {ns: 'common'})}><CoreApiError  requestState={inactivateGoogleUserTracking} /></ModalComponent>
            } else {
                return <ModalComponent
                    isOpen={true}
                    toggleModal={() => close(false)}
                    header={t('trackingOperations.google.inactivate.modalTitle', {ns: 'schoolAdministration'})}
                    cancel={t('action.cancel', {ns: 'common'})}>
                    <Loading />
                </ModalComponent>;
            }
        }
    }
}

export default InactivateGoogleUserTrackingWizard;
